import Vuex, { StoreOptions } from 'vuex'
import pathify from 'vuex-pathify'

import { IRootState } from './store.types'
import { profileStore } from '@/modules/profile/profile.store'
import appStore from '@/modules/app/app.store'

const plugins = [pathify.plugin]

export const storeOptions: StoreOptions<IRootState> = {
  plugins,
  modules: {
    app: appStore,
    profile: profileStore,
  },
}

export default new Vuex.Store<IRootState>(storeOptions)
